
import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core';

const InformationLine = ({ description, value, separator }) => (
  value ?
    <Typography className="informationLine">
      <b>{description}{separator !== undefined ? separator : ':'}</b> {value}
    </Typography>
    : null
)

InformationLine.propTypes = {
  description: PropTypes.any.isRequired,
  value: PropTypes.any,
  separator: PropTypes.string,
};

export default InformationLine
